// extracted by mini-css-extract-plugin
export default {"PrepareScoreTitle":"iStyles_PrepareScoreTitle__IIYcR","PrepareScoreSubTitle":"iStyles_PrepareScoreSubTitle__PzqEv"};